import { useTranslation } from "react-i18next";
import { z } from "zod";
import { regexNonEmptyString } from "../../common/regex";

export type UpsertRolePayload = {
	enabled?: boolean;
	description: string;
	permissions?: string[];
};

export const emptyRolePayload = {
	enabled: false,
	description: "",
	permissions: [],
};

/**
 * Returns validation schemas used to validate roles payloads.
 */
export const useRoleValidationSchemas = () => {
	const { t } = useTranslation("validation");

	const UpsertRoleSchema = z.object({
		enabled: z.boolean().nullable().optional(),
		permissions: z.array(z.string()).optional(),
		workspaces: z.array(z.string()).optional(),
		description: z.string().regex(regexNonEmptyString, t("common/required")),
	});

	return { UpsertRoleSchema };
};
